import ModelColorItemInterface from "../../../../interfaces/model/ModelColorItemInterface";
import {useEffect} from "react";

declare var $: any;

interface PriceFiltersProps {
    modelColorItems: ModelColorItemInterface[]
    fromPrice: number;
    toPrice: number;
    setFromPrice: (price: number) => void;
    setToPrice: (price: number) => void;
    getInitPriceRange: () => { min: number; max: number };
}

export default function PriceFilters({
    modelColorItems,
    fromPrice,
    toPrice,
    setFromPrice,
    setToPrice,
    getInitPriceRange
}: PriceFiltersProps) {

    const maxPrice = getInitPriceRange().max

    useEffect(() => {
        if (maxPrice) {
            $('.js-one-price-slider').data("ionRangeSlider")?.update({
                from: fromPrice,
                to: toPrice,
            })
        }
    }, [fromPrice, toPrice]);

    return (
        <div className="all-filters-block">
            <div className="all-filters-price">
                <p className="all-filters__title f-exp">Цена</p>
                <div className="range-wrap">
                    <div className="range-inputs">
                        <div className="range-inputs-group">
                            <input type="text" className="js-one-price-from" value={fromPrice}
                                   onChange={(event) => {
                                       setFromPrice(parseInt(event.target.value) || 0)
                                   }} onBlur={() => {
                                if (fromPrice < getInitPriceRange().min) {
                                    setFromPrice(getInitPriceRange().min)
                                }
                            }}/>
                            <p>от</p>
                        </div>
                        <div className="range-inputs-group">
                            <input type="text" className="js-one-price-to" value={toPrice}
                                   onChange={(event) => {
                                       setToPrice(parseInt(event.target.value) || 0)
                                   }} onBlur={() => {
                                if (toPrice > getInitPriceRange().max) {
                                    setToPrice(getInitPriceRange().max)
                                }
                            }}/>
                            <p>до</p>
                        </div>
                    </div>
                    <div className="range-slider">
                        <input type="text" className="js-one-price-slider"/>
                    </div>
                </div>
            </div>
        </div>
    );
}